import gql from 'graphql-tag';

import { PublicUserFragment, ProfileFragment } from '../fragments';

export default gql`
  ${PublicUserFragment}
  ${ProfileFragment}

  query adminInteraction($id: UUID!) {
    interaction(_id: $id) {
      _id
      _created
      _updated
      _createdBy {
        ...PublicUserFragment
      }
      _updatedBy {
        ...PublicUserFragment
      }
      user {
        _id
        name
        profile {
          ...ProfileFragment
        }
      }
      channel {
        _id
      }
      content {
        _id
      }
      startDate
      endDate
      geo
      data
      state
      features
      actions
      contentData
      version
      status
      lastStatus
      adminNote
    }
  }
`;
